import * as React from "react"
import { ImageProps, ImageStyle } from "react-native"
import { observer } from "mobx-react-lite"
import { AutoImage } from "../auto-image/auto-image"
import { View } from "native-base"
import { FC, useMemo } from "react"

const GRAY_SCALE: ImageStyle = {
  tintColor: 'rgba(128,128,128, 0.4)',
}

const IMAGE: ImageStyle = {
  position: 'absolute',
  opacity: 0.3,
}

export interface GrayscaleImageProps extends ImageProps {
  //
}

/**
 * Describe your component here
 */
export const GrayscaleImage: FC<GrayscaleImageProps> = observer(function GrayscaleImage(props) {
  const { style, ...restProps } = props

  const styleGrayStyle = useMemo(() => [style, GRAY_SCALE], [style])
  const styleImage = useMemo(() => [style, IMAGE], [style])

  return (
    <View>
      <AutoImage {...restProps} style={styleGrayStyle} />
      <AutoImage {...restProps} style={styleImage} />
    </View>
  )
})
